// extracted by mini-css-extract-plugin
export default {"externalLayout":"ExternalLayout_externalLayout__6dXMM","betaRibbon":"ExternalLayout_betaRibbon__AxiVw","ribbonPulse":"ExternalLayout_ribbonPulse__tJ9Yd"};